export default [
    {
        id: 1,
        name: 'coffee.jpg',
        alt: 'A cup of coffee with saucer and spoon',
        count: 0
    },
    {
        id: 2,
        name: 'posing.jpg',
        alt:
            'A person posing in ski gear with a background of mountains and snow',
        count: 0
    },
    { id: 3, name: 'coins.jpg', alt: 'A stack of coins', count: 0 },
    { id: 4, name: 'raspberries.jpg', alt: 'A bowl of raspberries', count: 0 }
];
